var $2f701b767fa6559c$exports = {};
$2f701b767fa6559c$exports = {
    "collectionLabel": `Forslag`
};


export {$2f701b767fa6559c$exports as default};
//# sourceMappingURL=nb-NO.module.js.map
